import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navigation from './components/Navigation';
import VersionRouter from './components/VersionRouter';
import FAQPage from './pages/FAQPage';
import CoursePage from './pages/CoursePage';
import V1HomePage from './pages/v1/V1HomePage';
import AuditedHomePage from './pages/audited/AuditedHomePage';
import AwesomeHomePage from './pages/awesome/AwesomeHomePage';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Navigation />
          <Routes>
            {/* Główna strona z obsługą query param ?version=X */}
            <Route path="/" element={<VersionRouter />} />
            {/* Bezpośrednie ścieżki do wersji (zachowane dla kompatybilności) */}
            <Route path="/v1" element={<V1HomePage />} />
            <Route path="/audited" element={<AuditedHomePage />} />
            <Route path="/awesome" element={<AwesomeHomePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/kurs/:courseSlug" element={<CoursePage />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
